import { v4 as uuidv4 } from "uuid";
import { FieldProps } from "../../utils/functionsInterfaces";
import { displayInfo } from "../../utils/messageToast";

export const handleAddAttachmentsFieldOutsideGroup = (
  setForm: React.Dispatch<React.SetStateAction<any[]>>,
  setButtonSave: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const newField: FieldProps = {
    uuid: uuidv4(),
    id: "",
    name: "",
    isRequired: false,
    isKey: false,
    type: "field",
    attribute: "",
    settings: {
      sizeLimit: { max: 10, enabled: true },
      allowedTypes: [
        "doc",
        "docx",
        "png",
        "jpg",
        "jpeg",
        "pdf",
        "xlsx",
        "xls",
        "eml",
        "msg",
        "txt",
        "xml",
        "xlt",
      ],
    },
    fieldType: "multiple_files",
  };
  setForm((prevForm) => [newField, ...prevForm]);
  setButtonSave(true);
  displayInfo("Campo de anexo criado!");
};
